namespace Matrix.Data {
    export interface InstanceRow {
        InstanceCode?: string;
        Name?: string;
    }

    export namespace InstanceRow {
        export const idProperty = 'InstanceCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.Instance';
        export const lookupKey = 'Data.Instance';

        export function getLookup(): Q.Lookup<InstanceRow> {
            return Q.getLookup<InstanceRow>('Data.Instance');
        }
        export const deletePermission = 'DataAdmin:Instance';
        export const insertPermission = 'DataAdmin:Instance';
        export const readPermission = 'Read:Instance';
        export const updatePermission = 'DataAdmin:Instance';

        export declare const enum Fields {
            InstanceCode = "InstanceCode",
            Name = "Name"
        }
    }
}
